module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "meals-calendar"
  }, [_c('page-bar'), _vm._v(" "), _c('h3', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "page-title"
  }, [_vm._v("Galeria")]), _vm._v(" "), _c('div', {
    staticClass: "portlet light "
  }, [_c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h4', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Filtrar por:")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 col-xs-6"
  }, [_c('label', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Nome do álbum:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.albumName),
      expression: "albumName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Nome do álbum"
    },
    domProps: {
      "value": (_vm.albumName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.albumName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-6"
  }, [_c('class-list', {
    attrs: {
      "label": 'Turmas:',
      "context": 'gallery'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-6"
  }, [_c('label', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Alunos:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.studentName),
      expression: "studentName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Digite o nome do aluno"
    },
    domProps: {
      "value": (_vm.studentName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.studentName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-xs-6"
  }, [_c('button', {
    staticClass: "btn btn-block yellow-gold pull-left m-t-24",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.filter
    }
  }, [_c('i', {
    staticClass: "fa fa-search",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Filtrar")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "portlet light"
  }, [_c('div', {
    staticClass: "portlet-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h4', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Lista de Álbuns")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2 m-t-10 m-b-15"
  }, [_c('router-link', {
    staticClass: "btn red-mint",
    attrs: {
      "to": "/gallery/album"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Criar novo álbum")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped table-bordered table-hover"
  }, [_c('thead', {
    staticClass: "bg-red-mint bg-font-red-mint"
  }, [_c('tr', [_c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Nome do álbum")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    attrs: {
      "width": "250px"
    }
  }, [_vm._v("Atribuído para")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    attrs: {
      "width": "130px"
    }
  }, [_vm._v("Nro de fotos")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    attrs: {
      "width": "200px"
    }
  }, [_vm._v("Criado por")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    attrs: {
      "width": "150px"
    }
  }, [_vm._v("Data de criação")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    attrs: {
      "width": "150px"
    }
  }, [_vm._v("Ações")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.list), function(album, index) {
    return _c('tr', [_c('td', {
      staticClass: "vertical-align-middle"
    }, [_vm._v(_vm._s(album.title))]), _vm._v(" "), (album.scope === 'ALL') ? _c('td', {
      staticClass: "vertical-align-middle"
    }, [_c('span', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }]
    }, [_vm._v("Para todos os alunos da escola.")])]) : _vm._e(), _vm._v(" "), (album.scope === 'SCHOOL_CLASS') ? _c('td', {
      staticClass: "vertical-align-middle"
    }, [_c('span', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }]
    }, [_vm._v("Turmas: ")]), _vm._v(" "), _vm._l((album.schoolClasses), function(klass, index) {
      return _c('span', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(klass.description)), (album.students) ? _c('span', {
        domProps: {
          "textContent": _vm._s(album.students.length !== index + 1 ? ',' : '.')
        }
      }) : _vm._e()])
    })], 2) : _vm._e(), _vm._v(" "), (album.scope === 'STUDENT') ? _c('td', {
      staticClass: "vertical-align-middle"
    }, [_c('span', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }]
    }, [_vm._v("Alunos: ")]), _vm._v(" "), _vm._l((album.students), function(student, index) {
      return _c('span', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(student.name)), (album.students.length) ? _c('span', {
        domProps: {
          "textContent": _vm._s(album.students.length !== index + 1 ? ',' : '.')
        }
      }) : _vm._e()])
    })], 2) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "vertical-align-middle"
    }, [_c('i', {
      staticClass: "fa fa-camera",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("  " + _vm._s(album.albumSize) + " fotos")]), _vm._v(" "), (album.creationUser) ? _c('td', {
      staticClass: "vertical-align-middle"
    }, [_vm._v(_vm._s(album.creationUser.name))]) : _vm._e(), _vm._v(" "), (!album.creationUser) ? _c('td', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }],
      staticClass: "vertical-align-middle"
    }, [_vm._v("Não informado")]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "vertical-align-middle"
    }, [_vm._v(_vm._s(_vm._f("date")(album.creationDateTime, "DD/MM/YYYY HH:mm")))]), _vm._v(" "), _c('td', [_c('router-link', {
      key: album.id,
      staticClass: "btn btn-block blue m-b-15",
      attrs: {
        "tag": "a",
        "to": {
          path: ("/gallery/album/" + (album.id))
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }]
    }, [_vm._v("Editar")])]), _vm._v(" "), (album.status == 'APPROVED') ? _c('button', {
      staticClass: "btn btn-block red-mint",
      attrs: {
        "tag": "a"
      },
      on: {
        "click": function($event) {
          _vm.unpublish(album.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }]
    }, [_vm._v("Despublicar")])]) : _vm._e(), _vm._v(" "), (album.status == 'CREATED' || album.status == 'IN_REVISION') ? _c('button', {
      staticClass: "btn btn-block green-jungle",
      attrs: {
        "tag": "a"
      },
      on: {
        "click": function($event) {
          _vm.publish(album.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-paper-plane-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }]
    }, [_vm._v("Publicar")])]) : _vm._e()], 1)])
  }))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 text-right"
  }, [(_vm.list.length > 0) ? _c('pagination', {
    attrs: {
      "layout": "prev, next"
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  }) : _vm._e()], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-038fcd4c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./sources/app/gallery/gallery.vue
// module id = 1031
// module chunks = 1